import { QueryClient } from '@tanstack/react-query';

/**
 * 全局唯一的 QueryClient。
 *
 * 抽成独立模块（而不是在 main.tsx 里 new）是为了让 authStore 在会话结束时能 clear()：
 * 换账号登录时，上一个账号的订单 / 客户 / 对账 / 通知等查询结果仍留在内存缓存里，
 * 新账号首屏会先渲染出旧账号的数据（含姓名、电话、地址等 PII），
 * 直到各自的请求返回才被覆盖——共用电脑时这就是跨账号信息泄露。
 */
export const queryClient = new QueryClient();
